import type { Types as Skola24Types } from '../types';
import type { OutTypes } from './schedule';

export default function (
  groups:   Skola24Types.group[],
  warnings: string[],
  errors:   string[]
): OutTypes.group[] {
  return groups.filter(x => x.bClass)
    .map(x => ({
      ids:         x.PK.toString(),
      displayName: x.ID,
      species:     'class',
    }));
}
